import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

const services = [
  {
    number: "01",
    title: "The Discovery Sprint\u2122",
    description:
      "2\u20134 weeks to validate your idea, find PMF signals, and build the blueprint.",
    price: "From $12K",
    href: "/discovery-sprint",
  },
  {
    number: "02",
    title: "The Build & Launch",
    description:
      "Hands-on MVP development, AI-powered workflows, and launch execution.",
    price: "From $15K / month · 3\u20136 mo",
    href: "/build-launch",
  },
  {
    number: "03",
    title: "AI Systems Layer",
    description:
      "Custom AI agents, automation, and intelligence tools deployed on top of your foundation.",
    price: "From $25K project · or $10K / mo retainer",
    href: "/ai-systems",
  },
];

export default function WhatIDo() {
  return (
    <section id="what-i-do" aria-label="What I Do" className="editorial-container section-spacing">
      {/* Section label */}
      <ScrollReveal>
        <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
          WHAT I DO
        </p>
      </ScrollReveal>

      {/* Section hook */}
      <ScrollReveal stagger={1}>
        <h2 className="mt-6 max-w-3xl font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
          Three things. That's all it takes to go from nothing to something
          real.
        </h2>
      </ScrollReveal>

      {/* Anti-positioning callout */}
      <ScrollReveal stagger={2} className="mt-10">
        <div className="border-l-2 border-accent bg-accent-subtle py-4 pl-6">
          <p className="text-body-lg text-foreground-muted md:text-body-lg-md">
            You don&rsquo;t need a dev shop. You don&rsquo;t need another
            advisor. You need a builder who&rsquo;s actually done this before.
          </p>
        </div>
      </ScrollReveal>

      {/* Service cards */}
      <div className="mt-16 grid gap-12 lg:grid-cols-3 lg:gap-8">
        {services.map((service, i) => (
          <ScrollReveal
            key={service.number}
            stagger={(i + 1) as 1 | 2 | 3}
          >
            <Link to={service.href} className="group block border-t border-accent pt-6">
              <span className="font-mono text-number text-accent">
                {service.number}
              </span>
              <h3 className="mt-4 font-display text-subsection font-semibold text-foreground md:text-subsection-md">
                {service.title}
              </h3>
              <p className="mt-3 text-foreground-muted">
                {service.description}
              </p>
              <p className="mt-4 font-mono text-small uppercase tracking-[0.05em] text-accent">
                {service.price}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 group-hover:gap-4">
                LEARN MORE <span aria-hidden="true">→</span>
              </span>
            </Link>
          </ScrollReveal>
        ))}
      </div>

      {/* Footer callout */}
      <ScrollReveal className="mt-16">
        <div className="border-l-2 border-accent bg-accent-subtle py-4 pl-6">
          <p className="text-body-lg font-medium text-foreground md:text-body-lg-md">
            Everything starts with the Discovery Sprint. No exceptions.
          </p>
        </div>
      </ScrollReveal>
    </section>
  );
}
